<template>
<modal :shown="shown" @close="hideModal" name="Finish later">
  <form class="form" v-if="!submitted">
    <p>We'll email you a link to your mix so you can pick up where you left off.</p>
    <div class="form-row">
      <label for="finish-later-email" class="form-label">Your Email</label>
      <div class="input-group" :class="{ 'has-error': $v.finishLaterEmail.$error, 'is-valid': $v.finishLaterEmail.required && $v.finishLaterEmail.email }">
        <input ref="finishLaterEmail" id="finish-later-email" type="text" class="form-control" v-model.trim="$v.finishLaterEmail.$model" autofocus>
        <div class="error" v-if="!$v.finishLaterEmail.required">Email is required</div>
        <div class="error" v-if="!$v.finishLaterEmail.email">Invalid email format</div>
      </div>
    </div>
    <div class="form-row">
      <button class="btn btn-primary has-arrow" @click.prevent="handleSubmit">Email my mix link</button>
    </div>
    <p v-if="submitMessage">{{ submitMessage }}</p>
  </form>
  <div v-if="submitted">
    <label for="mix-url" class="instructions">Save this code</label>
    <input type="text" id="mix-url" v-model="mixCode">
    <button class="btn btn-primary btn-copy" :class="{ 'copied': copySucceeded}"
      v-clipboard:copy="mixCode"
      v-clipboard:success="onCopySuccess"
      v-clipboard:error="onCopyError">Copy link to clipboard</button>
  </div>
</modal>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import axios from 'axios'
import Modal from '@/components/Modal'
export default {
  props: ['shown'],
  components: {
    'modal': Modal
  },
  data () {
    return {
      showModal: false,
      finishLaterEmail: null,
      submitted: false,
      submitMessage: null,
      mixCode: '',
      copySucceeded: false,
      saveData: {
        'path': this.$route.path,
        'formData': this.$store.state.formData
      }
    }
  },
  validations: {
    finishLaterEmail: { required, email }
  },
  methods: {
    handleSubmit () {
      this.copySucceeded = false
      this.submitMessage = null
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitMessage = 'Please correct the fields with errors.'
        this.submitted = false
      } else {
        this.submitMessage = 'Sending...'
        // send to WP for storage
        axios.post(this.$store.state.storeDomain + '/wp-json/millborn/v1/post/',
          {
            'recipient': this.finishLaterEmail,
            'saveData': this.saveData
          },
          {
            headers: {
              'Content-type': 'application/json'
            }
          })
          .then(response => {
            if (response.data.result === 'success') {
              this.mixCode = response.data.code
              this.$gtm.trackEvent({
                event: 'save-progress' // custom event triggers GA event tag
              })
              this.submitted = true
            } else {
              this.submitMessage = 'Sorry, the message could not be sent.'
              // console.log(response.data.message)
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    hideModal () {
      this.copySucceeded = false
      this.$emit('close')
    },
    onCopySuccess (e) {
      this.copySucceeded = true
    },
    onCopyError (e) {
      this.copySucceeded = false
    }
  },
  watch: {
    shown: function (newState, oldState) {
      this.$refs.finishLaterEmail.focus()
    }
  }
}
</script>

<style lang="scss">

</style>
